export default function Strengths() {
  const strengths = [
    {
      icon: 'ri-team-line',
      title: 'Experienced Management',
      description: 'TMI has an able pool of management that understands the commodity market very well and constantly follows trends. Our team brings over 40 years of combined experience across legal, mining, property, financial, marketing, sales, and engineering sectors.'
    },
    {
      icon: 'ri-links-line',
      title: 'Strategic Alliances',
      description: 'TMI has built strong strategic alliances with local and international players in the industry. This has helped boost confidence with clients that want to do business with TMI and strengthens our position in the market.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Advantage',
      description: 'While the market is controlled by big mining houses, TMI has set itself as a go-to supplier for clients that prefer to buy products from source as it is much cheaper. Big mining houses do not allow clients to buy locally as it reduces their profit margins—this becomes a winning trump card for TMI.'
    }
  ];

  const opportunities = [
    {
      icon: 'ri-global-line',
      title: 'High Demand Market',
      description: 'Chrome is one of the most bought minerals globally. South Africa has huge deposits of this mineral, making it an ideal area for global markets to source chrome from.'
    },
    {
      icon: 'ri-factory-line',
      title: 'Limited Competition',
      description: 'There is a very limited number of chrome processing plants in the market, making this opportunity very feasible. The available plants don\'t have capacity to supply the required quantities needed by clients.'
    },
    {
      icon: 'ri-arrow-up-line',
      title: 'Supply-Demand Gap',
      description: 'The demand for chrome is always higher than the supply component. Recently, main mining houses have been retrenching and lowering production levels, resulting in lower supplies and inevitably pushing prices higher.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Strengths Section */}
        <div className="mb-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 font-['Montserrat']">
              Our Strengths
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              What sets TMI apart in the chrome commodity market
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {strengths.map((strength, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-red-50 to-gray-50 p-8 rounded-lg"
              >
                <div className="w-16 h-16 bg-[#8B1538] rounded-full flex items-center justify-center mb-6">
                  <i className={`${strength.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-900 font-['Montserrat']">
                  {strength.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  {strength.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Opportunities Section */}
        <div>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 font-['Montserrat']">
              Market Opportunities
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Why the chrome market presents exceptional growth potential
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {opportunities.map((opportunity, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-red-50 p-8 rounded-lg"
              >
                <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center mb-6">
                  <i className={`${opportunity.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-900 font-['Montserrat']">
                  {opportunity.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  {opportunity.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
